<template>
  <content-layout>
    <form class="virtual-cards" @submit.prevent="postOrder">
      <header class="header">
        <div class="container">
          <div class="title">Лучший подарок для любимых сотрудников</div>
          <p>Здесь вы можете оформить заявку на подарочные карты парфюмерного супермаркета "Золотое Яблоко" и заказать доставку прямо в офис. Заявки принимаются от юридических лиц. Оплата производится безналичным платежом.</p>
        </div>
        <router-link :to="{ name: 'Index' }" class="go-back content-box-component">закрыть</router-link>
      </header>
      <div v-if="sended" class="content">
        <section>
          Благодарим за заказ! Наш менеджер свяжется с вами в ближайшее время.
        </section>
      </div>
      <div v-else class="content">
        <form @submit.prevent="postOrder">
          <section class="contacts recipient">
            <span class="input input--chisato" :class="{ 'input--filled': !!order.companyName, 'invalid': $v.order.companyName.$error }">
              <input class="field input__field input__field--chisato" id="recipient-org-name" type="text" @input="$v.order.companyName.$touch()" v-model="order.companyName" >
              <label class="input__label input__label--chisato" for="recipient-org-name">
                <span class="input__label-content input__label-content--chisato" data-content="Название организации">Название организации</span>
              </label>
            </span><br>
            <span class="input input--chisato" :class="{ 'input--filled': !!order.managerName, 'invalid': $v.order.managerName.$error }">
              <input class="field input__field input__field--chisato" id="recipient-name" @input="$v.order.managerName.$touch()" type="text" v-model="order.managerName" >
              <label class="input__label input__label--chisato" for="recipient-name">
                <span class="input__label-content input__label-content--chisato" data-content="Контактное лицо">Контактное лицо</span>
              </label>
            </span><br>
            <span class="input input--chisato" :class="{ 'input--filled': !!order.managerPosition }">
              <input class="field input__field input__field--chisato" id="recipient-position" type="text" v-model="order.managerPosition" >
              <label class="input__label input__label--chisato" for="recipient-position">
                <span class="input__label-content input__label-content--chisato" data-content="Должность">Должность</span>
              </label>
            </span><br><br>
            <div class="city-select" :class="{'invalid': $v.order.cityId.$error}">
              <select class="field select" name="city" v-model="order.cityId">
                <option value="">Выберите город</option>
                <option v-for="city in cities" :value="city.id" :key="city.id">{{ city.title }}</option>
              </select>
            </div>
            <span class="input input--chisato" :class="{ 'input--filled': !!order.email, 'invalid': $v.order.email.$error }">
              <input class="field input__field input__field--chisato" id="recipient-email" type="email" v-model="order.email" @input="$v.order.email.$touch()" >
              <label class="input__label input__label--chisato" for="recipient-email">
                <span class="input__label-content input__label-content--chisato" data-content="E-mail">E-mail</span>
              </label>
            </span>
            <span class="input input--chisato" :class="{ 'input--filled': !!order.phone, 'invalid': $v.order.phone.$error }">
              <masked-input
                    v-model="order.phone"
                    @input="$v.order.phone.$touch()"
                    class="field input__field input__field--chisato"
                    mask="\+\375 (11) 111 11 11"
                    id="recipient-phone"
              />
              <label class="input__label input__label--chisato" for="recipient-phone">
                <span class="input__label-content input__label-content--chisato" data-content="Телефон">+375 (__) ___ __ __</span>
              </label>
              <span class="code">+375</span>
            </span><br>
            <span class="input input--chisato" :class="{ 'input--filled': !!order.qty, 'invalid': $v.order.qty.$error }">
              <input class="field input__field input__field--chisato" id="recipient-card-count" @input="$v.order.qty.$touch()" type="number" v-model="order.qty" >
              <label class="input__label input__label--chisato" for="recipient-card-count">
                <span class="input__label-content input__label-content--chisato" data-content="Количество карт">Количество карт</span>
              </label>
            </span><br>
            <span class="input input_datapicker input--chisato input--filled" :class="{ 'invalid': $v.order.deliveryDate.$error }">
              <!-- <input class="field input__field input__field--chisato" id="delivery-date" type="date" :min="minDate" v-model="order.deliveryDate"> -->
              <datepicker
                ref="datepicker"
                :language="calendarLocales[lang]"
                :monday-first="true"
                :clear-button="true"
                v-on:selected="setDate"
                :disabled-dates="datepickerDisabled"
                @selected="$v.order.deliveryDate.$touch()"
                @cleared="order.deliveryDate = ''"
                wrapper-class="field input__field input__field--chisato"
                input-class="custom-input"
                id="delivery-date"
              />
              <label class="input__label input__label--chisato" for="delivery-date">
                <span class="input__label-content input__label-content--chisato" data-content="Дата доставки">Дата доставки</span>
              </label>
            </span><br>
            <span class="input input--chisato input--filled" :class="{ 'invalid': !requesitesIsValid }">
              <input class="field input__field input__field--chisato" id="requisites" @change="addRequisites" type="file">
              <label class="input__label input__label--chisato" for="requisites">
                <span class="input__label-content input__label-content--chisato" data-content="Реквизиты">Реквизиты</span>
              </label>
            </span><br>
            <span class="input input--chisato" :class="{ 'input--filled': !!order.comment }">
              <input class="field input__field input__field--chisato" id="recipient-comment" type="text" v-model="order.comment" >
              <label class="input__label input__label--chisato" for="recipient-comment">
                <span class="input__label-content input__label-content--chisato" data-content="Комментарий">Комментарий</span>
              </label>
            </span><br>
          </section>
        </form>
        <section class="subtotal dark">
          <button class="buy big">Отправить заявку</button>
        </section>
      </div>
    </form>
  </content-layout>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import { apiUrl } from '@/config.js'
import { getTopPosition } from '@/utils.js'
import ContentLayout from '@/components/ContentLayout.vue'
import MaskedInput from 'vue-masked-input'
import Datepicker from 'vuejs-datepicker'
import { ru } from 'vuejs-datepicker/dist/locale'

const now = new Date()
const yesterday = new Date(new Date().getTime() - 24 * 60 * 60 * 1000)
const today = {
  day: now.getDate(),
  month: now.getMonth() + 1,
  year: now.getFullYear()
}

export default {
  name: 'corp-clients',
  mixins: [validationMixin],
  data () {
    return {
      lang: 'ru',
      calendarLocales: { ru: ru },
      sended: false,
      cities: [],
      order: {
        companyName: '',
        managerName: '',
        managerPosition: '',
        cityId: '',
        email: '',
        phone: '',
        qty: '',
        deliveryDate: '',
        comment: ''
      },
      requisites: '',
      requesitesIsValid: true,
      now: now,
      minDate: `${today.year}-${today.month.length === 2 ? today.month : '0' + today.month}-${today.day}`,
      datepickerDisabled: {
        to: yesterday
      }
    }
  },
  validations: {
    order: {
      cityId: {
        required
      },
      companyName: {
        required
      },
      managerName: {
        required
      },
      email: {
        required,
        email
      },
      phone: {
        required
      },
      deliveryDate: {
        required
      },
      qty: {
        required
      }
    }
  },
  components: {
    ContentLayout,
    MaskedInput,
    Datepicker
  },
  computed: {},
  created () {
    axios.get(`${apiUrl}/cards`)
      .then(({ data }) => {
        this.cities = data.cities
      })
      .catch(console.error)
  },
  mounted () {
    this.$v.$reset()
  },
  methods: {
    scrollToFirtsInvalid () {
      this.$nextTick(function () {
        window.scrollTo({ top: getTopPosition(document.querySelectorAll('.invalid')[0]), behavior: 'smooth' })
      })
    },
    setDate (date) {
      this.order.deliveryDate = moment(date).format('YYYY-MM-DD')
    },
    addRequisites (e) {
      this.requisites = [...e.target.files]
      this.checkRequisites()
    },
    checkRequisites () {
      this.requesitesIsValid = !!this.requisites.length
    },
    postOrder () {
      this.$v.$touch()
      if (!this.$v.order.$error) {
        /* eslint-disable no-undef */
        const data = new FormData()
        Object.keys(this.order).forEach(key => {
          data.append(key, this.order[key])
        })
        data.append('requisites', this.requisites[0])
        axios.post(`${apiUrl}/order/corporative`, data)
          .then(({ data }) => {
            this.sended = true
          })
          .catch(({ reponse }) => {
            console.error(response.data)
            window.location.replace('/modal/error')
          })
      } else {
        this.scrollToFirtsInvalid()
      }
    }
  }
}
</script>

<style src="@/components/Cards.css" scoped/>
